<div class="admin-page-wrap">
  <h1 class="page-title"><i class="bi bi-collection me-2"></i> Content</h1>
  <p class="page-subtitle">Manage courses, subjects, topics, areas, and questions. Use the tabs to switch between content types.</p>

  <ul class="nav nav-tabs mb-3">
    <li class="nav-item">
      <button type="button" class="nav-link" [class.active]="activeTab === 'courses'" (click)="setTab('courses')">Courses</button>
    </li>
    <li class="nav-item">
      <button type="button" class="nav-link" [class.active]="activeTab === 'subjects'" (click)="setTab('subjects')">Subjects</button>
    </li>
    <li class="nav-item">
      <button type="button" class="nav-link" [class.active]="activeTab === 'topics'" (click)="setTab('topics')">Topics</button>
    </li>
    <li class="nav-item">
      <button type="button" class="nav-link" [class.active]="activeTab === 'areas'" (click)="setTab('areas')">Areas</button>
    </li>
    <li class="nav-item">
      <button type="button" class="nav-link" [class.active]="activeTab === 'questions'" (click)="setTab('questions')">Questions</button>
    </li>
  </ul>

  @if (activeTab === 'courses') {
    <app-admin-courses [embedded]="true"></app-admin-courses>
  } @else if (activeTab === 'subjects') {
    <app-admin-subjects [embedded]="true"></app-admin-subjects>
  } @else if (activeTab === 'topics') {
    <app-admin-topics [embedded]="true"></app-admin-topics>
  } @else if (activeTab === 'areas') {
    <app-admin-areas [embedded]="true"></app-admin-areas>
  } @else if (activeTab === 'questions') {
    <app-admin-questions [embedded]="true"></app-admin-questions>
  }
</div>
